var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"xl":"8","lg":"11","md":"12","cols":"12"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }